import $ from 'jquery';

/**
 * mi-sticky: JS-driven fixed positioning that crosses container boundaries.
 * Optimized with hardware acceleration and placeholder locking to eliminate scroll flicker.
 *
 * Classes:
 *   .mi-sticky        — the element that becomes fixed
 *   .mi-sticy-parent  — the container where the sticky element lives
 *   .mi-sticky-end    — (optional) boundary where sticky stops
 */
const miSticky = () => {
	const $navbar = $('.mi-navbar--main');
	const instances = [];

	$('.mi-sticky').each(function () {
		const $el = $(this);
		const $parent = $el.closest('.mi-sticy-parent');
		if (!$parent.length) return;

		const $placeholder = $('<div>')
			.addClass('mi-sticky-placeholder')
			.hide();
		$el.before($placeholder);

		instances.push({ $el, $parent, $placeholder });
	});

	if (!instances.length) return;

	// Find visible .mi-sticky-end relative to a given element
	const findEnd = ($el, $parent) => {
		const $tabPanel = $el.closest('[role="tabpanel"]');
		if ($tabPanel.length) {
			const $end = $tabPanel.find('.mi-sticky-end').filter(function () {
				return (
					this.offsetWidth > 0 ||
					this.offsetHeight > 0 ||
					this.getClientRects().length > 0
				);
			});
			if ($end.length) return $end;
			// If inside a tab panel and no visible .mi-sticky-end exists in this tab, return null
			return null;
		}

		// Global visible .mi-sticky-end (only if visible in DOM)
		const $global = $('.mi-sticky-end').filter(function () {
			return (
				this.offsetWidth > 0 ||
				this.offsetHeight > 0 ||
				this.getClientRects().length > 0
			);
		});
		return $global.length ? $global : null;
	};

	const reset = (inst) => {
		inst.$el.removeClass('is-fixed is-abs-bottom').css({
			position: '',
			top: '',
			bottom: '',
			width: '',
			left: '',
			transform: '',
			willChange: '',
		});
		inst.$placeholder.hide();
	};

	const updateInstance = (inst) => {
		try {
			const el = inst.$el[0];
			const parent = inst.$parent[0];

			// Skip if parent is hidden/detached
			if (!parent.offsetWidth && !inst.$el.hasClass('is-fixed')) {
				reset(inst);
				return;
			}

			const navH = $navbar.length ? $navbar[0].offsetHeight : 0;
			const adminH = $('#wpadminbar').length ? $('#wpadminbar')[0].offsetHeight : 0;
			const $heading = inst.$el.closest('.mi-tabs, .e-n-tabs').find('.e-n-tabs-heading.is-sticky');
			const headingH = $heading.length ? $heading.outerHeight() : 0;
			const stickyTop = navH + adminH + headingH;

			const parentRect = parent.getBoundingClientRect();
			const parentWidth = parentRect.width;
			const elH = inst.$el.outerHeight();

			if (parentWidth <= 0 || elH <= 0) {
				reset(inst);
				return;
			}

			// Boundary check (ignore hidden .mi-sticky-end from other inactive tabs)
			const $end = findEnd(inst.$el, inst.$parent);
			const boundaryBottom =
				$end && $end.length
					? $end[0].getBoundingClientRect().bottom
					: parentRect.bottom;

			const shouldFix =
				parentRect.top <= stickyTop && boundaryBottom > stickyTop + elH;
			const shouldAbsBottom =
				parentRect.top <= stickyTop && boundaryBottom <= stickyTop + elH;

			if (shouldFix) {
				// Lock placeholder size to prevent parent collapse
				inst.$placeholder.css({
					height: elH + 'px',
					display: 'block',
				});

				inst.$el
					.addClass('is-fixed')
					.removeClass('is-abs-bottom')
					.css({
						position: 'fixed',
						top: stickyTop + 'px',
						bottom: '',
						width: parentWidth + 'px',
						left: parentRect.left + 'px',
						transform: 'translate3d(0, 0, 0)', // Hardware GPU acceleration
						willChange: 'position, top, left',
					});
			} else if (shouldAbsBottom) {
				inst.$placeholder.css({
					height: elH + 'px',
					display: 'block',
				});

				const offsetTop = boundaryBottom - parentRect.top - elH;
				inst.$el
					.addClass('is-abs-bottom')
					.removeClass('is-fixed')
					.css({
						position: 'absolute',
						top: offsetTop + 'px',
						bottom: '',
						width: parentWidth + 'px',
						left: '',
						transform: '',
						willChange: '',
					});
			} else {
				reset(inst);
			}
		} catch (e) {
			reset(inst);
		}
	};

	let ticking = false;
	const requestUpdate = () => {
		if (!ticking) {
			requestAnimationFrame(() => {
				instances.forEach(updateInstance);
				ticking = false;
			});
			ticking = true;
		}
	};

	$(window).on('scroll resize', requestUpdate);

	// Re-run on Elementor tab switches
	$(document).on(
		'click',
		'.e-n-tab-title, .elementor-tab-title',
		function () {
			instances.forEach(reset);
			setTimeout(requestUpdate, 150);
			setTimeout(requestUpdate, 500);
		},
	);

	requestUpdate();
};

$(function () {
	try {
		miSticky();
	} catch (error) {
		console.warn('mi-sticky:', error);
	}
});
